import { render, staticRenderFns } from "./carbon.vue?vue&type=template&id=1b2ea77f&"
import script from "./carbon.vue?vue&type=script&lang=js&"
export * from "./carbon.vue?vue&type=script&lang=js&"
import style0 from "./carbon.vue?vue&type=style&index=0&id=1b2ea77f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports